import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import Global from '../../../store/global-selectors';
import {
  calculateShipFromIdAndSellerFulfillmentProviderId,
  getNewCswTypeId,
  useCSWTypeId,
  useShipFromState,
  useSaveEntitiesUpdate,
} from '../../../fulfillment-planner';

export const useSaveShipFrom = (fulfillmentPlanId, selectedShipFromId) => {
  const { serviceId } = useSelector((state) => Global.selectEntitiesFulfillmentPlanById(state, { fulfillmentPlanId }));

  const { updateCSWTypeId } = useCSWTypeId(fulfillmentPlanId, undefined, getNewCswTypeId);
  const { saveEntitiesUpdate } = useSaveEntitiesUpdate(fulfillmentPlanId);

  const onConfigurationChange = useCallback(
    (update, options) => {
      const newShipFromId = update.shipFromId;

      const { shipFromId: internalShipFromId, sellerFulfillmentProviderId: externalShipFromId } =
        calculateShipFromIdAndSellerFulfillmentProviderId(newShipFromId);

      const newCSWTypeId = updateCSWTypeId(internalShipFromId, externalShipFromId, serviceId);

      const payload = {
        shipFromId: internalShipFromId,
        sellerFulfillmentProviderId: externalShipFromId,
      };
      saveEntitiesUpdate(payload, newCSWTypeId, options);
    },
    [serviceId, updateCSWTypeId, saveEntitiesUpdate],
  );

  const { onShipFromChange } = useShipFromState(fulfillmentPlanId, selectedShipFromId, onConfigurationChange);

  return onShipFromChange;
};
